var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Customer } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.customers = [];
        this.loaded = false;
        this.set = function (customers) {
            _this.customers = customers.map(function (customer) { return new Customer(customer); });
            _this.loaded = true;
        };
        this.push = function (customer) {
            _this.customers.push(new Customer(customer));
        };
        this.replace = function (customer) {
            _this.customers.splice(_this.customers.findIndex(function (f) { return f.id === customer.id; }), 1, customer);
        };
        this.pull = function (customer) {
            _this.customers.splice(_this.customers.findIndex(function (a) { return a.id === customer.id; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('customer/' + id).then(function (customer) { return new Customer(customer); });
        return api.get('customer').then(this.set);
    };
    default_1.prototype.create = function (customer) {
        return api.post('customer', customer).then(this.push);
    };
    default_1.prototype.update = function (id, customer) {
        return api.put('customer/' + id, customer).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('customer/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "customers", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Customers/Store.ts
// module id = 683
// module chunks = 0